// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ImportWorkspaceSchema } from './v1/import/workspaceSchema';

export const listImportWorkspacesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
});

export const listImportWorkspacesHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of workspaces
 */
export const listImportWorkspaces200Schema = z.array(z.lazy(() => v1ImportWorkspaceSchema));

export const listImportWorkspacesQueryResponseSchema = z.lazy(() => listImportWorkspaces200Schema);
